<style lang="stylus">
    .aibot-container-component
        position absolute
        left 50%
        top 50%
        min-width 480px
        min-height 144px
        background-color #fff
        background-image url(../assets/img/ai/ai-bot-bg.png)
        background-repeat no-repeat
        background-size cover
        z-index 100
        border-radius 8px
        box-shadow 0px 15px 30px rgba(0, 0, 0, .15)
        user-select none
        outline none
        .dialog-title
            position relative
            display flex
            justify-content space-between
            align-items center
            height 40px
            width 100%
            cursor move
            .header-prefix
                display flex
                align-items center
                margin-left 24px
                &>span
                    margin 0 4px
                // 覆盖 iview tooltip 默认样式
                .tips-mark
                    cursor pointer
                    .ivu-tooltip-rel
                        display flex
                        align-items center
                    .ivu-tooltip-inner
                        border-radius 8px
                        padding 16px
                        background-color var(--bg-color-tips)
                        box-shadow $box-shadow
                    // 位置修正
                    .ivu-tooltip-popper[x-placement^=right]
                        top 6px !important
                        .ivu-tooltip-arrow
                            top 10px
                            border-right-color var(--bg-color-tips)
            .header-suffix
                display flex
                align-items center
                background-color var(--bg-color-box-hover)
                border-radius 32px
                height 24px
                padding 0 12px
                margin-right 32px
                color var(--themeColor)
                font-weight normal
                a
                    color var(--themeColor)
                    &:hover
                        text-decoration underline
            .title-close
                color var(--svg-color-gray-42)
                position absolute
                top 50%
                left 50%
                transform translate(-50%, -50%)
                stroke $modal-title-textcolor
                width 16px
                height 16px
                svg
                    width 16px
                    height 16px
    .dialog-content
        padding 6px 24px
        .input-container
            position relative
            .command-input
                &.force-height
                    textarea
                        height 36px !important
                &::after
                    display none
                    content attr(data-count)
                    position absolute
                    bottom 8px
                    right 36px
                    color #909399
                    padding 0 4px
                textarea
                    min-height 36px !important
                    font-size 12px
                    padding 8px 32px 8px 12px
                    border-radius 6px
                    resize none
            .ivu-input-group-append
                background-color white
            .input-suffix
                position absolute
                bottom 6px
                right 6px
                width 24px
                height 24px
                cursor pointer
                border-radius 6px
                &:hover
                    background rgba(0, 0, 0, .06)
                >svg
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%, -50%)
                    stroke $modal-title-textcolor
                    width 16px
                    height 16px
        .dialog-content
            padding 6px 24px
            .input-container
                position relative
                .command-input
                    &::after
                        content attr(data-count)
                        position absolute
                        bottom 8px
                        right 36px
                        color #909399
                        padding 0 4px
                    textarea
                        min-height 36px !important
                        font-size 12px
                        padding 8px 32px 8px 12px
                        border-radius 6px
                        resize none
                .ivu-input-group-append
                    background-color white
                .input-suffix
                    position absolute
                    bottom 6px
                    right 6px
                    height 24px
                    width 24px
                    cursor pointer
                    color var(--themeColor)
                    &.disabled
                        color #0160c0
                        cursor not-allowed
                    &:hover
                        color #0177f0
                .ai-loading
                    position absolute
                    bottom 8px
                    right 8px
                    height 20px
                    width 20px
                    cursor not-allowed
            .ai-menu-tip
                color var(--text-color-tertiary)
                margin 16px 0 8px 0
            .ai-menu
                display grid
                grid-template-columns 1fr 1fr 1fr
                gap 8px
                margin-bottom 10px
                .ai-menu-list
                    display flex
                    align-items center
                    background #f6f8fb
                    border-radius 6px
                    padding 8px 16px
                    cursor pointer
                    img
                        height 24px
                        margin-right 8px
                    &:hover,
                    &.active
                        background rgba(1, 127, 255, 0.1)
            .animation-img
                display flex
                justify-content center
                align-items center
                margin 16px 44px
                img
                    height 48px
        @keyframes waves {
            from {
                background-position: 0%;
            }
            to {
                background-position: 100%;
            }
        }
</style>

<template>
    <div tabindex="-1" ref="dialogRootEle" class="aibot-container-component" :style="{ top: top + 'px', left: left + 'px' }">
        <div class="dialog-title" @mousedown="move($event)">
            <div class="header-prefix">
                <img v-show="activeKey" :src="require('@/app/assets/back.svg')" style="cursor: pointer" @click="resetInput" draggable="false" />
                <img :src="require('@/app/assets/img/ai/ai-text-icon.svg')" draggable="false" />
                <span>{{ activeKey ? $t(this.activeKey) : $t("defaultTitle") }}</span>
                <Tooltip v-show="!activeKey" class="tips-mark" :max-width="330" placement="right-start">
                    <img src="@/app/assets/img/ai/question-mark.svg" alt="" />
                    <div slot="content">
                        <p style="margin-bottom: 6px">{{ $t("agreement") }}</p>
                        <p>1. {{ $t("tips1") }}</p>
                        <p>2. {{ $t("tips2") }}</p>
                        <p>3. {{ $t("tips3") }}</p>
                        <p>4. {{ $t("tips4") }}</p>
                    </div>
                </Tooltip>
            </div>
            <div class="header-suffix">
                <img src="@/app/assets/img/ai/ai-point.svg" alt="" draggable="false" />
                <a :href="pointLink" target="_blanke">{{ $t("points") + ": " + pointNum }}</a>
            </div>
            <div class="title-close" @click="closeDialog()" @mousedown.stop><iconSymbol name="Del" /></div>
        </div>
        <div class="dialog-content">
            <div class="input-container">
                <Input
                    v-model="inputText"
                    ref="commandInput"
                    class="command-input"
                    :class="{ 'force-height': inputText.length == 0 }"
                    type="textarea"
                    :maxlength="200"
                    :autosize="{ minRows: 1, maxRows: 5 }"
                    :placeholder="placeholders"
                    @on-keyup="calcRows"
                />
                <iconSymbol class="input-suffix" :class="{ disabled: commandLoaing }" :name="'paperPlane'" @click.stop.native="goGenerating" />
                <img v-show="commandLoaing" class="ai-loading" :src="require('@/app/assets/loading.gif')" alt="" draggable="false" />
            </div>
            <div v-if="activeKey" class="animation-img">
                <div v-show="commandLoaing" :style="animationClass"></div>
                <img v-show="!commandLoaing" :src="require('@/app/assets/img/ai/ai-animation-static.png')" alt="" draggable="false" />
            </div>
            <template v-else>
                <p class="ai-menu-tip">{{ $t("aiMenuTip") }}</p>
                <div class="ai-menu">
                    <div class="ai-menu-list" v-for="item in menuList" :key="item.key" @click="handleClicks(item.key)">
                        <img :src="item.img" draggable="false" />
                        <p>{{ item.label }}</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import { Watch, Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import AiSocket from "@/app/mixin/aiSocket";
    import { parseMermaidText } from "@/public/utils/tool.js";

    @Component({
        components: { MenuList },
    })
    export default class Base extends AiSocket {
        contentWidth = 0; // 内容宽度
        contentHeight = 0; // 内容高度
        x = 0;
        y = 0;
        top = 0;
        left = 0;
        activeKey: string = "";
        commandLoaing: boolean = false;
        points: number = 0; // 剩余点数
        pointNum = ""; // 剩余点数
        inputCount: string = "";
        // restText: string = ""; // 剩余体验字数

        get menuList() {
            return [
                // { key: "text", label: this.$t("text"), img: require("@/app/assets/img/ai/ai-menu-text.png") },
                {
                    key: "flow",
                    label: this.$t("flow"),
                    img: require("@/app/assets/img/ai/ai-menu-flow.png"),
                },
                {
                    key: "mindmap",
                    label: this.$t("mindmap"),
                    img: require("@/app/assets/img/ai/ai-menu-mindmap.png"),
                },
                {
                    key: "list",
                    label: this.$t("list"),
                    img: require("@/app/assets/img/ai/ai-menu-list.png"),
                },
                // { key: "timeline", label: this.$t("timeline"), img: require("@/app/assets/img/ai/ai-menu-timeline.png") },
                {
                    key: "form",
                    label: this.$t("form"),
                    img: require("@/app/assets/img/ai/ai-menu-form.png"),
                },
            ];
        }
        get pointLink() {
            const availableLang = ["de", "fr", "es", "pt", "it", "jp"].includes(this.lang) ? `/${this.lang}` : "no";
            let host = this.internal
                ? "https://www.edrawsoft.cn/order/recharge-page.html"
                : `https://www.edrawsoft.com${availableLang}/pricing-ai-edrawmax.html`;
            if (!this.internal && availableLang == "no") {
                host = "https://edrawmax.wondershare.com/store/pricing-ai.html";
            }
            if (!this.internal && this.lang == "en") {
                // 仅en跳转固定链接
                host = "https://www.edrawmax.com/store/effects-buy.html";
            }
            let custom = encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })));
            return `${host}?product=max&platform=maxonline&custom=${custom}`;
        }
        get animationClass() {
            return {
                width: "100%",
                height: "48px",
                background: `url(${require("@/app/assets/img/ai/ai-animation-frames.png")}) 0 0 no-repeat`,
                backgroundSize: "5100%",
                animation: "waves steps(50) 2.5s infinite both",
                animationPlayState: this.commandLoaing ? "" : "paused",
            };
        }
        get placeholders() {
            const map = {
                flow: this.$t("placeholder1"),
                mindmap: this.$t("placeholder2"),
                list: this.$t("placeholder3"),
                form: this.$t("placeholder4"),
            };
            return map[this.activeKey] || this.$t("placeholder");
        }

        @Watch("inputText")
        inputChange(val) {
            if (val && !this.activeKey) {
                this.activeKey = "text";
            } else if (!val && this.activeKey == "text") {
                this.activeKey = "";
            }
        }
        goGenerating() {
            if (["flow", "mindmap", "list", "form"].includes(this.activeKey) && !this.inputText) {
                this.inputText = this.placeholders;
            }
            if (!this.inputText) {
                this.$edMessage.error(this.$t("emptyTheme"));
                return;
            }
            this.commandLoaing = true;

            let typeMap = {
                text: ["continue", "Q&A"],
                flow: ["flowchart", "Flow Chart"],
                mindmap: ["mindmap-md", "Mind Mapping"],
                list: ["chat", "List"],
                form: ["form", "Sheet"],
            };
            let values = typeMap[this.activeKey],
                type = values[0],
                sensorType = values[1];

            this.sensors.track("ClickGenerateButton", {
                Catalogues: "AI",
                generate_type: sensorType,
            });
            this.aiPromise(type)
                .then(() => {
                    let _view = window["_view"],
                        page = _view._activePage;
                    // 文本续写
                    if (this.activeKey == "text") {
                        let textList = this.resultText.split("\n");
                        textList.unshift(this.inputText);
                        _view.generateTextTemplate(page, textList);
                    }
                    // 生成流程图
                    if (this.activeKey == "flow") {
                        // const parserObj = parseMermaidText(this.resultText);
                        // _view.generateFlowFromMermaid(page, parserObj);
                        _view.generateFlow(page, this.resultText);
                    }
                    // 生成多级思维导图
                    if (this.activeKey == "mindmap") {
                        _view.generateMindMap(page, this.inputText, this.resultText);
                    }
                    // 生成列表
                    if (this.activeKey == "list") {
                        let textList = this.resultText.split("\n");
                        textList.unshift(this.inputText);
                        _view.generateListTemplate(page, textList);
                    }
                    // 生成表格
                    if (this.activeKey == "form") {
                        _view.generateForm(page, this.resultText);
                    }
                    this.checkPoint(true);
                })
                .finally(() => {
                    this.commandLoaing = false;
                });
        }
        handleClicks(key) {
            if (["text", "flow", "mindmap", "list", "form"].includes(key)) {
                this.activeKey = key;
            }
        }
        resetInput() {
            this.activeKey = "";
            this.inputText = "";
        }
        // 计算文本实际行数，包括自动换行的情况
        calcRows() {
            let textarea = (this.$refs.commandInput as any).$el.firstChild,
                lineHeight = parseInt(getComputedStyle(textarea).lineHeight);
            let inputRows = Math.floor(textarea.scrollHeight / lineHeight);
            this.inputCount = this.inputText.length && inputRows > 1 ? this.inputText.length + "/200" : "";
        }
        get aiConsumePointsVisble() {
            return this.$store.state.staticConfig.aiConsumePointsVisble;
        }
        get aiConsumePointsText() {
            return this.$store.state.staticConfig.aiConsumePointsText;
        }
        // 检查剩余点数
        checkPoint(showUse = false) {
            this.$edApi.getPoints(this.userInfo).then((res) => {
                const used = this.points - res.balance;
                if (used > 0 && showUse && this.aiConsumePointsVisble) {
                    let usedStr = `<span style="color: #09c2ff">${used}</span>`;
                    let str = this.aiConsumePointsText
                        ? this.aiConsumePointsText.replace(/%1/, usedStr)
                        : (this.$t("pointToast") as string).replace(/\%used\%/, usedStr);
                    this.$edMessage.info(str, 3);
                }
                this.points = res.balance;
                let num = res.balance;
                if (num > 100000) {
                    this.pointNum = `${Math.floor(num / 1000)}K`;
                } else {
                    this.pointNum = num;
                }
                // this.restText = `${res.gpt_balance_nums}/${res.gpt_total_nums}`;
            });
        }
        move(e) {
            this.x = e.clientX;
            this.y = e.clientY;
            let left = this.left;
            let top = this.top;
            document.onmousemove = (e) => {
                this.left = left + e.clientX - this.x;
                this.top = top + e.clientY - this.y;
            };
            document.onmouseup = () => {
                document.onmousemove = null;
            };
        }
        closeDialog() {
            this.$store.commit("setStatus", {
                type: "showAIBotDialog",
                data: false,
            });
        }
        keyEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeDialog();
            }
            if (e.keyCode == 13 && (e.metaKey || e.ctrlKey)) {
                // ctrl + enter
                this.goGenerating();
            }
        }

        refreshAiPoint() {
            console.log("aibot visible event");
            this.checkPoint();
        }
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        aiPromise(...args) {
            if (this.$store.state.user.noLoginEditor) {
                return this.generatingNologin(...args);
            } else {
                return this.generating(...args);
            }
        }

        created() {
            this.$bus.$on("appVisible", this.refreshAiPoint);
            this.checkPoint();
            !this.noLoginEditor && this.initAiSocket();
            document.addEventListener("keydown", this.keyEvent);
        }
        mounted() {
            // 如果同时有两个弹窗 用document.querySelector获取的都是第一个元素dom
            let dom = this.$refs.dialogRootEle as HTMLElement;
            this.left = (document.documentElement.clientWidth - dom.clientWidth) / 2;
            this.top = (document.documentElement.clientHeight - dom.clientHeight) / 2;
            if (this.contentWidth && this.contentHeight) {
                this.left = (document.documentElement.clientWidth - this.contentWidth) / 2;
                this.top = (document.documentElement.clientHeight - this.contentHeight) / 2;
            }
            this.$nextTick(() => {
                // 等待底部图片加载完成后，重置宽度后再次刷新textarea高度
                let inputDom = this.$refs.commandInput as any;
                if (inputDom) {
                    console.log("resize textarea");
                    inputDom.resizeTextarea();
                }
            });
        }
        beforeDestroy() {
            this.$bus.$off("appVisible", this.refreshAiPoint);
            document.removeEventListener("keydown", this.keyEvent);
        }
    }
</script>
<i18n>
{
    "zh": {
        "agreement": "《亿图AI功能使用协议》",
        "tips1": "亿图AI功能为用户提供便捷的文字内容生成服务；",
        "tips2": "本功能仅用于学习交流使用，不可以用于商业用途；",
        "tips3": "本功能生成的内容无法保证100%准确性，请您知悉；",
        "tips4": "您需要合法合规使用本功能，并为由此可能产生的法律风险进行负责。",
        "points": "剩余AI点数",
        "pointToast": "AI智能助手已完成本次指令，消耗了%used%点AI点数",
        "placeholder": "输入问题，与AI互动回答，或帮你生成以下内容",
        "placeholder1": "用户注册登录系统的流程",
        "placeholder2": "《西游记》读书笔记",
        "placeholder3": "项目管理的关键技巧",
        "placeholder4": "五行六列的班级成绩表",
        "defaultTitle": "智能助手",
        "aiMenuTip": "解锁更多热门玩法",
        "text": "问答",
        "flow": "生成流程图",
        "mindmap": "生成思维导图",
        "list": "生成列表",
        "timeline": "生成时间线",
        "form": "生成表格",
        "emptyTheme": "主题文本不能为空"
    },
    "en": {
        "agreement": "Edraw AI Function Use Agreement",
        "tips1": "Edraw AI function provides users with convenient text generation services;",
        "tips2": "This function is only used for learning and communication, and cannot be used for commercial purposes;",
        "tips3": "The content generated by this function cannot guarantee 100% accuracy, please be aware;",
        "tips4": "You need to use this function legally and compliantly, and be responsible for the legal risks that may arise from it.",
        "points": "Remaining AI points",
        "pointToast": "The AI smart assistant has followed the instruction and used %used% AI points",
        "placeholder": "Input queries, communicate with the AI and get help with generating content",
        "placeholder1": "User registration and login system process",
        "placeholder2": "\\\"Journey to the West\\\" reading notes",
        "placeholder3": "Key Skills in Project Management",
        "placeholder4": "Five rows and six columns",
        "defaultTitle": "AI Assistant",
        "aiMenuTip": "Unlock more popular functions",
        "text": "Q&A",
        "flow": "Create Flowchart",
        "mindmap": "Create Mind Map",
        "list": "Create List",
        "timeline": "生成时间线",
        "form": "Create Table",
        "emptyTheme": "Subject text cannot be empty"
    },
    "de": {
        "agreement": "„Nutzungsvereinbarung für die Edraw AI-Funktion“",
        "tips1": "Die Edraw AI-Funktion bietet Benutzern praktische Dienste zur Textgenerierung;",
        "tips2": "Diese Funktion dient ausschließlich zu Lern- und Kommunikationszwecken und kann nicht für kommerzielle Zwecke genutzt werden;",
        "tips3": "Bitte beachten Sie, dass für die von dieser Funktion generierten Inhalte keine 100%ige Genauigkeit garantiert werden kann;",
        "tips4": "Diese Funktion muss rechtsgültig und ordnungsgemäß genutzt werden. Sie sind für die rechtlichen Risiken verantwortlich, die sich daraus ergeben können.",
        "points": "Verbleibende AI-Punkte",
        "pointToast": "AI Smart Assistant hat die Anweisung ausgeführt und dafür %used% AI-Punkte verwendet",
        "placeholder": "Sie können Anfragen eingeben, mit dem Assistenten kommunizieren und erhalten Hilfe bei der Erstellung von Inhalten",
        "placeholder1": "Systemprozess der Benutzerregistrierung und -anmeldung",
        "placeholder2": "Lesenotizen zu „Die Reise nach Westen\\\"",
        "placeholder3": "Schlüsselkompetenzen im Projektmanagement",
        "placeholder4": "Zeugnis mit fünf Zeilen und sechs Spalten",
        "defaultTitle": "AI Assistent",
        "aiMenuTip": "Weitere beliebte Funktionen freischalten",
        "text": "Q&A",
        "flow": "Flussdiagramm erstellen",
        "mindmap": "Mindmap erstellen",
        "list": "Liste erstellen",
        "timeline": "生成时间线",
        "form": "Tabelle erstellen",
        "emptyTheme": "Betreff darf nicht leer sein"
    },
    "es": {
        "agreement": "«Acuerdo de uso de la función de AI de Edraw»",
        "tips1": "La función de AI de Edraw proporciona a los usuarios prácticos servicios para generar textos;",
        "tips2": "Esta función se utiliza únicamente para el aprendizaje y la comunicación, y no se puede utilizar con fines comerciales;",
        "tips3": "Ten en cuenta que el contenido generado por esta función no puede garantizar una precisión del 100%;",
        "tips4": "Debes utilizar esta función de forma legal y conforme a la normativa, y se te considerará responsable de todos los riesgos legales que puedan derivarse de ella.",
        "points": "Puntos de AI restantes",
        "pointToast": "El asistente inteligente de IA ha seguido la instrucción y ha utilizado %used% puntos de IA",
        "placeholder": "Introduzca su consulta, comuníquese con la IA y reciba ayuda para generar contenido",
        "placeholder1": "User registration and login system process",
        "placeholder2": "Notas de lectura «Viaje al Oeste»",
        "placeholder3": "Habilidades clave en la gestión de proyectos",
        "placeholder4": "Hoja de calificaciones de clase de cinco filas y seis columnas",
        "defaultTitle": "Asistente de AI",
        "aiMenuTip": "Desbloquear más funciones populares",
        "text": "Preguntas y respuestas",
        "flow": "Crear diagrama de flujo",
        "mindmap": "Crear mapa mental",
        "list": "Crear lista",
        "timeline": "生成时间线",
        "form": "Crear tabla",
        "emptyTheme": "El texto del asunto no puede estar vacío"
    },
    "fr": {
        "agreement": "«Contrat d'utilisation de la fonction IA d'Edraw»",
        "tips1": "La fonction IA d'Edraw fournit aux utilisateurs des services utiles de génération de texte.",
        "tips2": " Cette fonction est uniquement utilisée à des fins d'apprentissage et de communication et ne peut pas être utilisée à des fins commerciales.",
        "tips3": "Le contenu généré par cette fonction ne garantit pas une précision irréprochable.",
        "tips4": "Vous devez utiliser cette fonction de manière légale et conforme, et êtes responsable des risques juridiques qui peuvent en découler.",
        "points": "Points IA restants",
        "pointToast": "L'assistant IA a suivi les instructions et utilisé %used% points IA",
        "placeholder": "Saisissez des requêtes, communiquez avec l'IA et obtenez de l'aide pour générer du contenu.",
        "placeholder1": "Processus d'enregistrement des utilisateurs et de connexion au système",
        "placeholder2": "« La Pérégrination vers l'Ouest » : notes de lecture",
        "placeholder3": "Compétences clés en gestion de projet",
        "placeholder4": "Feuille de notation à cinq lignes et six colonnes",
        "defaultTitle": "Assistente AI",
        "aiMenuTip": "Déverrouiller des fonctions plus populaires",
        "text": "Domande e risposte",
        "flow": "Créer un organigramme",
        "mindmap": "Créer une carte mentale",
        "list": "Créer une liste",
        "timeline": "生成时间线",
        "form": "Créer une table",
        "emptyTheme": "Le texte de l'objet ne peut pas être vide."
    },
    "it": {
        "agreement": "Contratto di utilizzo per la funzione Edraw AI",
        "tips1": "La funzione Edraw AI offre agli utenti servizi pratici di generazione testo",
        "tips2": "Questa funzione viene utilizzata solo per scopi di apprendimento e comunicazione e non può essere utilizzata per scopi commerciali",
        "tips3": "Tieni presente che l'accuratezza del contenuto generato da questa funzione non può essere garantita al 100%",
        "tips4": "L'utilizzo di questa funzione deve essere conforme alle normative vigenti. L'utente viene ritenuto responsabile dei rischi legali previsti in caso di utilizzo non conforme alle normative vigenti.",
        "points": "Punti AI rimanenti",
        "pointToast": "L'assistente AI ha seguito l'istruzione e ha utilizzato %used% punti AI",
        "placeholder": "Inserisci le query, comunica con l'intelligenza artificiale e ottieni aiuto per la generazione dei contenuti",
        "placeholder1": "Processo di registrazione e accesso al sistema dell'utente",
        "placeholder2": "\\\"Journey to the West\\\" leggerà le note",
        "placeholder3": "Competenze chiave nella gestione dei progetti",
        "placeholder4": "Foglio di valutazione della classe a cinque righe e sei colonne",
        "defaultTitle": "Assistente AI",
        "aiMenuTip": "Sblocca le funzioni più popolari",
        "text": "Domande e risposte",
        "flow": "Crea diagramma di flusso",
        "mindmap": "Crea mappa mentale",
        "list": "Crea elenco",
        "timeline": "生成时间线",
        "form": "Crea tabella",
        "emptyTheme": "Il testo dell'oggetto non può essere vuoto"
    },
    "jp": {
        "agreement": "「Edraw AI機能利用規約」",
        "tips1": "Edraw AI機能により、ユーザーは手ごろなテキスト生成サービスを利用できます。",
        "tips2": "この機能は、学習とコミュニケーションのみを目的としたものであり、商業目的で使用することはできません。",
        "tips3": "この機能で生成されたコンテンツは、100%の正確性を保証することはできませんのでご注意ください。",
        "tips4": "お客様は、この機能を合法的かつコンプライアンスに基づいて使用し、それによって生じる可能性のある法的リスクに対して責任を負う必要があります。",
        "points": "AIポイント残り",
        "pointToast": "AIスマートアシスタントは指示に従い、%used%AIポイントを使用しました",
        "placeholder": "クエリを入力し、AIと対話してコンテンツの生成を手伝ってもらいます",
        "placeholder1": "ユーザー登録とログインシステムプロセス",
        "placeholder2": "「西遊記」の読書のノート",
        "placeholder3": "プロジェクトマネジメントにおける重要なスキル",
        "placeholder4": "5行と6列のクラスグレードシート",
        "defaultTitle": "AIアシスタント",
        "aiMenuTip": "より一般的な機能を利用できます",
        "text": "Q&A",
        "flow": "フローチャートを作成",
        "mindmap": "マインドマップを作成",
        "list": "リストを作成",
        "timeline": "生成时间线",
        "form": "テーブルを作成",
        "emptyTheme": "件名のテキストは空白にできません"
    },
    "kr": {
        "agreement": "Edraw AI 기능 사용 계약",
        "tips1": "Edraw AI 기능은 사용자에게 편리한 텍스트 생성 서비스를 제공합니다.",
        "tips2": "이 기능은 학습 및 의사소통을 위해서만 사용되며, 상업적 목적으로 사용할 수 없습니다.",
        "tips3": "이 기능으로 생성된 콘텐츠는 100% 정확성을 보장할 수 없다는 점을 명심해 주시기 바랍니다.",
        "tips4": "사용자는 이 기능을 합법적으로 규정에 따라 사용해야 하며, 이로 인해 발생할 수 있는 법적 위험에 책임을 져야 합니다.",
        "points": "잔여 AI 포인트",
        "pointToast": "AI 스마트 Assistant가 지침을 따르고 AI %used% 포인트를 사용했습니다.",
        "placeholder": "궁금한 점을 입력하고 AI와 대화하여 콘텐츠 생성에 도움을 받을 수 있습니다.",
        "placeholder1": "사용자 등록 및 로그인 시스템 프로세스",
        "placeholder2": "\\\"서부로 가는 여정(Journey to the West)\\\" 읽기 노트",
        "placeholder3": "프로젝트 관리의 핵심 기술",
        "placeholder4": "5행 6열 수업 성적 시트",
        "defaultTitle": "AI Assistant",
        "aiMenuTip": "더 많은 인기 있는 기능을 사용할 수 있습니다.",
        "text": "Q&A",
        "flow": "순서도 만들기",
        "mindmap": "마인드 맵 만들기",
        "list": "목록 만들기",
        "timeline": "生成时间线",
        "form": "표 만들기",
        "emptyTheme": "제목 텍스트를 비워둘 수 없음"
    },
    "pt": {
        "agreement": "Contrato de utilização da função de IA do Edraw",
        "tips1": "A função de IA do Edraw fornece aos usuários convenientes serviços de geração de texto;",
        "tips2": "Esta função é usada apenas para aprendizagem e comunicação e não pode ser usada para fins comerciais;",
        "tips3": "O conteúdo gerado por esta função não garante 100% de precisão;",
        "tips4": "Você deve usar esta função legalmente e de forma adequada e ser responsável pelos riscos legais que possam surgir;",
        "points": "Pontos de IA restantes",
        "pointToast": "O assistente inteligente de IA seguiu as instruções e usou os pontos de IA %used%",
        "placeholder": "Faça consultas, comunique-se com a IA e obtenha ajuda para gerar conteúdo",
        "placeholder1": "Processo do sistema de registro e login do usuário",
        "placeholder2": "Notas de leitura de \\\"Jornada para o Oeste\\\"",
        "placeholder3": "Principais habilidades para o Gerenciamento de Projetos",
        "placeholder4": "Folha de notas da turma com cinco linhas e seis colunas",
        "defaultTitle": "Assistente com IA",
        "aiMenuTip": "Desbloquear mais funções populares",
        "text": "Perguntas e respostas",
        "flow": "Criar fluxograma",
        "mindmap": "Criar mapa mental",
        "list": "Criar lista",
        "timeline": "生成时间线",
        "form": "Criar tabela",
        "emptyTheme": "O texto do assunto não pode estar vazio"
    },
    "tw": {
        "agreement": "「Edraw AI 功能使用協議」",
        "tips1": "Edraw AI 功能為使用者提供便利的文字產生服務；",
        "tips2": "此功能僅用於學習和溝通，無法用於商業用途；",
        "tips3": "請注意，此功能產生的內容無法保證 100% 準確；",
        "tips4": "您必須依法律及規定使用此功能，並對其可能產生的法律風險負責。",
        "points": "剩餘 AI 點數",
        "pointToast": "AI 智慧助理已按照指示運作，並已使用 %used%個 AI 點數",
        "placeholder": "輸入查詢、與 AI 溝通，並取得產生內容的相關協助",
        "placeholder1": "使用者註冊和登入系統流程",
        "placeholder2": "「西遊記」閱讀筆記",
        "placeholder3": "專案管理的關鍵技能",
        "placeholder4": "五列六欄式班級成績工作表",
        "defaultTitle": "AI 助理",
        "aiMenuTip": "解鎖更多熱門功能",
        "text": "問與答",
        "flow": "建立流程圖",
        "mindmap": "建立心智圖",
        "list": "生成列表",
        "timeline": "建立清單",
        "form": "建立表格",
        "emptyTheme": "主旨文字不可空白"
    }
}
</i18n>
